import { render } from "./SubmitModal.vue?vue&type=template&id=47ad2ab9"
import script from "./SubmitModal.vue?vue&type=script&lang=js"
export * from "./SubmitModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__